import { mainApiAxios as axios } from '@/plugins/axios'
import { useStripHtml } from '@/helpers/common.js'

export default {
    

    listSurveys(isSharedMuni, analyticsType = '') {
        return axios.get(`surveys?isSharedMuni=${isSharedMuni}&analyticsTypeId=${analyticsType}`)
    },
    listQuestionIcons() {
        return axios.get('surveys/question-icons')
    },
    listFilterQuestions(analyticsType, surveyId) {
        return axios.get(`surveys/FilterQuestions?analyticsType=${analyticsType}&surveyId=${surveyId}`)
    },
    listCSATOptions(analyticsType, surveyId) {
        return axios.get(`surveys/CSATOptions?analyticsType=${analyticsType}&surveyId=${surveyId}`)
    },
    listAllFilterQuestions(analyticsType) {
        return axios.get(`surveys/FilterQuestions?analyticsType=${analyticsType}`)
    },
    listAllCSATOptions(analyticsType, surveyId) {
        return axios.get(`surveys/CSATOptions?analyticsType=${analyticsType}`)
    },
    listSurveyMainAnalytics(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/main-analytics`, obj)
    },
    listSurveyAnalyticsPerRegion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/main-analytics-regions`, obj)
    },
    listAnalyticsQuestions(surveyId, analyticsType, iconId) {
        return axios.get(`surveys/${surveyId}/analyticsquestions/${analyticsType}/${iconId ? iconId:''}`)
    },
    listSakaniSatisfaction(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction`, obj)
    },
    listSakaniSatisfactionfromCSAT3(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-csat3`, obj)
    },
    listSakaniSatisfactionAllRecordsAsync(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/csat51`, obj)
    },
    listCSAT52(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/csat52`, obj)
    },
    listSakaniTripleSatisfaction(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/sakani-triple-satisfaction`, obj)
    },
    listEndorsmentResults(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/endorsment`, obj)
    },
    listSakaniSatisfactionPerQuestion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-perquestion`, obj)
    },
    listSakaniSatisfactionPerQuestion4(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-perquestion4`, obj)
    },
    listSakaniSatisfactionPerQuestion3(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-perquestion3`, obj)
    },
    listAwarenessPerQuestion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/awareness-perquestion`, obj)
    },
    listRegionsPerQuestion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/regions-perquestion`, obj)
    },
    listSakaniSatisfactionPerQuestion2(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-perquestion2`, obj)
    },
    listSakaniSatisfactionQuarters(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-quarters`, obj)
    },
    listSakaniSatisfactionCSATQuarters(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/sakani-satisfaction-csat-quarters`, obj)
    },
    listGenders(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/genders`, obj)
    },
    listNPSResults(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/nps-chart`, obj)
    },
    listSignedQuestionAnswers(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/signedquestion-answers`, obj)
    },
    listPrecommunication(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/precommunication`, obj)
    },
    listReservation(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/reservation`, obj)
    },
    listSpiderResults(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/spiderchart`, obj)
    },
    listProfessions(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/professions`, obj)
    },
    listSakaniProducts(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/sakani-products`, obj)
    },
    listPublications(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/publications`, obj)
    },
    listCommunicationReasons(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/communication-reasons`, obj)
    },

    listEucationalLevels(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/educational-level`, obj)
    },

    listNationalities(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/nationality`, obj)
    },

    listAgeGroup(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions, questionId }
        return axios.post(`surveys/${surveyId}/age-group`, obj)
    },
    listRidaAveragePerQuestion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities: municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/rida-intishar-average-perquestion/6`, obj)
    },
    listRidaAveragePerMunicipality(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities: municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/rida-intishar-average-permunicipality`, obj)
    },
    listIntisharAveragePerQuestion(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities: municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/rida-intishar-average-perquestion/7`, obj)
    },
    listHeatMap(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities: municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/heat/6`, obj)
    },
    listHeatMapIntishar(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/heat/7`, obj)
    },
    listIntisharQuarters(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/rida-intishar-quarters/7`, obj)
    },
    listRidaQuarters(surveyId, municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions) {
        var obj = { municipalities, selectedYear, selectedQuarter, analyticsType, filterQuestions }
        return axios.post(`surveys/${surveyId}/rida-intishar-quarters/6`, obj)
    },

    shareSurvey(surveyId, shared) {
        return axios.post(`surveys/${surveyId}/share?shared=${shared}`)
    },

    listMySubmissionsSurveys() {
        return axios.get('surveys/current/submissions')
    },

    getSurveyFormById(surveyId) {
        return axios.get(`surveys/form/${surveyId}`)
    },

    getPublicSurveyFormById(surveyId, language) {
        return axios.get(`surveys/form/public/${surveyId}/${language}`)
    },
    previewSurveyFormById(surveyId, language) {
        return axios.get(`surveys/form/preview/${surveyId}/${language}`)
    },
    async exportSurveyToPdf(surveyId, data) {
        const response = await axios.post(`surveys/${surveyId}/analytics/pdf`, data, {
            responseType: 'blob'
        })
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'SurveyReport.pdf')
        document.body.appendChild(link)
        link.click()

        // Clean up
        link.parentNode.removeChild(link)
        window.URL.revokeObjectURL(url)
    },
    addSurvey(surveyObj, majorChange) {
        surveyObj.nameAr = useStripHtml(surveyObj.nameAr)
        surveyObj.nameEn = useStripHtml(surveyObj.nameEn)
        return axios.post(`surveys?majorChange=${majorChange}`, surveyObj)
    },
    generateSurvey(surveyObj) {
        surveyObj.nameAr = useStripHtml(surveyObj.nameAr)
        surveyObj.nameEn = useStripHtml(surveyObj.nameEn)
        return axios.post('surveys/genAI', surveyObj)
    },
    updateSurveyTime(surveyId, avgTime) {
        var obj = { surveyId, avgTime }
        return axios.post('surveys/update-avg-time', obj)
    },
    copySurvey(surveyObj) {
        return axios.post('surveys/Copy-Survey', surveyObj, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    vote(surveyId, surveyObj, latitude, longitude, startTime, isDraft, participantId) {

        var day = startTime.getDate()       // yields date
        var month = startTime.getMonth() + 1    // yields month (add one as '.getMonth()' is zero indexed)
        var year = startTime.getFullYear()  // yields year
        var hour = startTime.getHours()     // yields hours 
        var minute = startTime.getMinutes() // yields minutes
        var second = startTime.getSeconds() // yields seconds

        // After this construct a string with the above results as below
        var dateTime = month + '/' + day + '/' + year + ' ' + hour + ':' + minute + ':' + second

        return axios.post(`surveys/${surveyId}/vote?latitude=` + latitude + '&longitude=' + longitude + '&startTime=' + dateTime + '&IsDraft=' + isDraft + (participantId ? '&participantId=' + participantId : ''), surveyObj)
    },

   

    listSurveyResults(surveyId, page, pageSize, trickyQuestionValidated, durationValidated, patternValidated) {
        return axios.get(`surveys/${surveyId}/results?page=${page}&pageSize=${pageSize}&trickyQuestionValidated=${(trickyQuestionValidated != null ? trickyQuestionValidated : '')}&durationValidated=${(durationValidated != null ? durationValidated : '')}&patternValidated=${(patternValidated != null ? patternValidated : '')}`)
    },

    listSurveyMyResults(surveyId, page, pageSize) {
        return axios.get(`surveys/${surveyId}/my-results?page=${page}&pageSize=${pageSize}`)
    },
    listMyAnswers(participantId) {
        return axios.get(`surveys/${participantId}/myanswers`)
    },
    loadSurveyAnalytics(surveyId, fromDate, toDate) {
        return axios.get(`surveys/${surveyId}/analytics?fromDate=${(fromDate ? fromDate : '')}&toDate=${(toDate ? toDate : '')}`)
    },

    listHomePageSurveys(language) {
        return axios.get('surveys/home?language=' + language)
    },
    listStatisticsHome() {
        return axios.get('surveys/StatisticsHome')
    },
    loadSurvey(surveyId) {
        return axios.get(`surveys/${surveyId}`)
    },
    loadSurveywithoutAuth(surveyId) {
        return axios.get(`surveys/GetNoAuthSurvey/${surveyId}`)
    },
    deleteSurvey(surveyId) {
        return axios.post(`surveys/deleteSurvey/${surveyId}`)
    },
    exportToExcel(surveyId, fromDate, toDate, trickyQuestionValidated, durationValidated, patternValidated) {
        return axios.get(`surveys/${surveyId}/export-results?fromDate=${fromDate}&toDate=${toDate}&trickyQuestionValidated=${(trickyQuestionValidated != null ? trickyQuestionValidated : '')}&durationValidated=${(durationValidated != null ? durationValidated : '')}&patternValidated=${(patternValidated != null ? patternValidated : '')}`, { responseType: 'blob' })
    },
    exportToExcelForEdit(surveyId) {
        return axios.get(`surveys/${surveyId}/export-answers`, { responseType: 'blob' })
    },
    importExcelForEdit(surveyId, formData) {
        return axios.post(`surveys/${surveyId}/import-answers`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    },
    uploadFiles(files, questId) {
        return axios.post(`surveys/uploadFiles?questId=${questId}`, files)
    },
    loadSurveyAnalyticsShared(surveyId, selectedItems, fromDate, toDate) {
        var sharedIds = selectedItems.join(',')
        if (sharedIds == '') {
            sharedIds = 'empty'
        }
        return axios.get(`surveys/${surveyId}/analyticsShared?sharedIds=${sharedIds}&fromDate=${(fromDate ? fromDate : '')}&toDate=${(toDate ? toDate : '')}`)
    },
}